import { useState } from "react";
import styled from "styled-components";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import loginImage from "../assets/Mayo/Login_Background.jpg";
import gistLogo from "../assets/Mayo/Logo_Gist_White.svg";
import { LoginStyle } from "../tenants/mayo/login/LoginForm";

function Header() {
  return(
    <HeaderContainer>
      <GistLogo src={gistLogo} />
    </HeaderContainer>
  );
}

const ForgotPassword = () => {
  const navigate = useNavigate();
  const hospital = JSON.parse(localStorage.getItem("hospital") || "null");
  const hospitalName = hospital?.name?.toLowerCase() || "";
  const [email, setEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    
    if (!email.trim()) {
      setErrorMessage("Please enter your email address.");
      return;
    }

    setIsLoading(true);

    try {
      await axios.post("/api/staffMembers/forgot-password", { email, hospitalName });
      setEmailSent(true);
    } catch (error) {
      console.error("Forgot password error:", error.response?.data);
      setErrorMessage(
        error.response?.data?.message || 
        "An error occurred. Please try again later."
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleResend = () => {
    setEmailSent(false);
    setEmail("");
    setErrorMessage("");
  };

  if (emailSent) {
    return (
      <>
        <LoginStyle />
        <Container>
          <Header />
          <FormWrapper>
            <Title>Reset Password</Title>
            <SuccessMessage>
              We emailed you a link to reset your password.
            </SuccessMessage>
            <ResendSection>
              <ResendText>
                Didn't receive an email? Check your spam or{" "}
                <ResendLink onClick={handleResend}>click here to resend</ResendLink>.
              </ResendText>
            </ResendSection>
            <BackButton onClick={() => navigate(hospitalName ? `/login/${hospitalName}` : "/login")}>
              Back to Login
            </BackButton>
          </FormWrapper>
        </Container>
      </>
    );
  }

  return (
    <>
      <LoginStyle />
      <Container>
        <Header />
        <FormWrapper>
          <Title>Reset Password</Title>
          <SubText>Please enter your E-mail address:</SubText>
          <FormContainer onSubmit={handleSubmit}>
            <InputWrapper>
              <Input
                type="email"
                placeholder="E-Mail"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                error={errorMessage}
                disabled={isLoading}
                required
              />
            </InputWrapper>
            <ErrorWrapper>
              {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
            </ErrorWrapper>
            <Button type="submit" disabled={isLoading}>
              {isLoading ? "Sending..." : "Send"}
            </Button>
            <BackButton type="button" onClick={() => navigate(hospitalName ? `/login/${hospitalName}` : "/login")}>
              Back to Login
            </BackButton>
          </FormContainer>
        </FormWrapper>
      </Container>
    </>
  );
};

export default ForgotPassword;

// ========================= STYLES =========================

const Container = styled.div`
  background-image: url("${loginImage}");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  color: #1A1A1A;
  font-family: Abraham;
  width: 100vw;
  min-height: 100vh;
  overflow: auto;
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  height: fit-content;
  margin-top: 4.63vh;
  margin-inline: 24px;
  z-index: 2;
`;

const GistLogo = styled.img`
  fill: white;
  height: 7.2vh;
`;

const MayoLogo = styled.img`
  fill: white;
  height: 11.2vh;
`;

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  position: fixed;
  left: 190px;
  top: 50%;
  transform: translateY(-50%);
  width: 30.677vw;
  min-width: 420px;
  max-width: 560px;
  max-height: 90vh;

  padding: 7.87vh 2vw 6.48vh 2vw;
  overflow-y: auto;

  border-radius: 3.645vw;
  z-index: 1;

  background-color: #FFFFFF00;
  backdrop-filter: blur(30px) brightness(1.2);
  -webkit-backdrop-filter: blur(30px) brightness(1.2);
`;

const Title = styled.p`
  font-size: 2.6vw;
  font-weight: 600;
  margin: 0;
  margin-bottom: 0.463vw;
  text-align: center;
`;

const SubText = styled.p`
  font-size: 1.2vw;
  font-weight: 400;
  margin: 0;
  margin-bottom: 3vh;
  text-align: center;
  width: 80%;
`;

const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 19vw;
`;

const InputWrapper = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 1.5vh;
`;

const Input = styled.input`
  width: calc(100% - 2.9166vw);
  background: white;
  border-radius: 1.51vw;
  opacity: 0.8;
  border: ${(props) => props.error ? "2px solid #F02A4C;" : "0"};
  padding: 1.481vh 1.458vw 1.296vh 1.458vw;
  font-size: 0.9375vw;

  &::placeholder {
    opacity: 50%;
    font-size: 0.9375vw;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const ErrorWrapper = styled.div`
  min-height: 2.22vh;
  margin-bottom: 1.5vh;
  width: 100%;
`;

const ErrorMessage = styled.p`
  color: #F02A4C;
  font-size: 0.9375rem;
  font-weight: 600;
  text-align: center;
  margin: 0;
`;

const Button = styled.button`
  width: 8.85vw;
  height: 4.62vh;
  background: #F02A4C;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 29px;
  border: 0;
  font-size: 0.9375vw;
  font-weight: 500;
  color: white;
  cursor: pointer;
  margin-bottom: 1vh;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    background: #d0253a;
  }
`;

const BackButton = styled.button`
  width: 8.85vw;
  height: 4.62vh;
  background: transparent;
  border: 2px solid #F02A4C;
  border-radius: 29px;
  font-size: 0.9375vw;
  font-weight: 500;
  color: #F02A4C;
  cursor: pointer;
  margin-top: 0.5vh;

  &:hover {
    background: #F02A4C;
    color: white;
  }
`;

const SuccessMessage = styled.p`
  font-size: 1.2rem;
  font-weight: 500;
  text-align: center;
  margin: 0;
  margin-bottom: 2rem;
  color: #333;
  width: 80%;
  line-height: 1.5;
`;

const ResendSection = styled.div`
  margin-bottom: 2rem;
  width: 80%;
`;

const ResendText = styled.p`
  font-size: 0.9375vw;
  text-align: center;
  margin: 0;
  color: #666;
  line-height: 1.5;
`;

const ResendLink = styled.span`
  color: #F02A4C;
  cursor: pointer;
  text-decoration: underline;
  font-weight: 600;

  &:hover {
    color: #d0253a;
  }
`;

